import React from "react";
import CountryLayout from "@/components/CountryLayout";

export default function CountryBelgium() {
  return <CountryLayout countryKey="belgium" countryCode="be" sourcePage="/countries/belgium" />;
}
